import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Tag } from 'antd';
import UserImage from 'src/components/layout/UserImage';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

const StylesWrapper = styled.div`
  .conv-history-left-image {
    width: 9px;
    height: 9px;
    color: #6466f1;
  }

  .conv-history-right-image {
    width: 9px;
    height: 9px;
    color: #6466f1;
  }

  .conv-history-item-left {
    border-radius: 0 0.8rem 0.8rem 0.8rem;
  }

  .conv-history-item-right {
    border-radius: 0.8rem 0 0.8rem 0.8rem;
  }

  .conv-history-item-posting {
    filter: blur(1px);
    opacity: 0.6;
  }

  .conv-history-item-new {
    opacity: 1;
    animation-name: item-new-animation;
    animation-duration: 500ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
  }

  .conv-history-item-new-left {
    transform-origin: left;
  }

  .conv-history-item-new-right {
    transform-origin: right;
  }

  @keyframes item-new-animation {
    50% {
      transform: scale(1.2);
    }
  }
`;

const ConversationHistoryItem = ({ side, item }) => {
  return (
    <StylesWrapper>
      <div className={`m-4 ${item.isPosting ? 'conv-history-item-posting animate-pulse' : item.isNew ? `conv-history-item-new conv-history-item-new-${side}` : null}`}>
        <div className='px-11 pb-1'>
          <div className={`flex gap-2 items-center text-xs ${'right' === side ? 'flex-row-reverse' : 'flex-row'}`}>
            <div>
              {dayjs(item?.created_at).fromNow()} by {item?.user_name ?? 'Unknown user'}{' '}
            </div>
            {item.visibility === 'internal' && (
              <Tag color='orange' style={{ margin: 0, fontSize: '0.8rem' }}>
                internal
              </Tag>
            )}
          </div>
        </div>
        <div className={`flex  ${'right' === side ? 'flex-row-reverse' : 'flex-row'} gap-2`}>
          <div className='w-9 text-center'>
            <UserImage image={item?.user_pic} size={32} />
          </div>
          {/* <div className='flex'>{'right' === side ? <RightImage className='conv-history-right-image' /> : <LeftImage className='conv-history-left-image' />}</div> */}

          <div className={`py-1 px-3 conv-history-item-${side} max-w-[90%] border border-solid border-gray-200 dark:border-gray-800 content-center`} dangerouslySetInnerHTML={{ __html: item?.text }} />
        </div>
      </div>
    </StylesWrapper>
  );
};

ConversationHistoryItem.propTypes = {
  item: PropTypes.object.isRequired,
  side: PropTypes.string.isRequired,
};

ConversationHistoryItem.defaultProps = {
  side: 'left',
};

export default ConversationHistoryItem;
